import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="pages"
export default class extends Controller {
  static targets = ["page"];
  static values = { urls: Object, md5: String };

  pages = [];
  md5 = false;

  connect() {
    this.screenController = this.element.closest('.screen').controller;
    this.element.controller = this;

    this.messages();
    this.interval = setInterval(this.messages.bind(this), 10000);
  }

  messages() {
    fetch(this.urlsValue.messages).then((response) => {
      response.json().then((data) => {
        this.views = [];

        data.messages.forEach((message) => {
          switch (message.kind) {
            case "signal":
              switch (message.name) {
                case "reload":
                  window.location.reload();
                  break;
                default:
                  document.body.classList.add('signal--' + message.name);

                  setTimeout(() => {
                    document.body.classList.remove('signal--' + message.name);
                  }, 5000);
              }
              break;
            case "refresh":
              window.location.reload();
              break;
            case "pages":
              if (this.md5Value == message.md5) return;

              this.md5Value = message.md5;

              fetch(message.url).then((response) => {
                response.json().then((data) => {
                  this.element.innerHTML = "";

                  data.pages.forEach((page) => {
                    let html = page.html;
                    html = html.replace("%md5%", page.md5);

                    this.element.insertAdjacentHTML("beforeend", html);
                  });

                  this.pages = data.pages;

                  clearTimeout(this.timeout);
                  this.timeout = setTimeout(this.play.bind(this));
                });
              });
          }
        });
      });
    });
  }

  findElementById(id) {
    return this.element.querySelector(`.page[data-page-id-value="${id}"]`);
  }


  reset() {
    if (this.timeout) clearTimeout(this.timeout);

    this.pageTargets.forEach((page, index) => {
      page.controller.hide();
    });

    this.play()
  }

  run(pages) {
    let duration = 0;

    pages.forEach((page) => {
      duration += page.controller.durationValue;
    });

    return new Promise((resolve, reject) => {

      if (duration == 0) {
        setTimeout(resolve, 2000);
        return;
      }

      let interval = setInterval(() => {
        let time = Math.round(Date.now() / 1000)

        let result = (time % duration) == 0;

        if (result) {
          setTimeout(this.reset.bind(this), duration * 1000);
          resolve();
          clearInterval(interval);
        }
      }, 75);

    })
  }

  play() {
    if (!this.screenController.syncValue) {
      this.next();
      return;
    }

    let activeAdvertisements = this.pageTargets.filter((page) => {
      return page.controller.scheme();
    });

    this.run(activeAdvertisements).then(() => {
      this.next();
    })
  }

  next() {
    if (this.timeout) clearTimeout(this.timeout);

    let activeAdvertisements = this.pageTargets.filter((page) => {
      return page.controller.scheme();
    });

    let page = this.pageTargets.find((page) => page.controller.visibleValue);

    if (!page && activeAdvertisements.length == 0) {
      this.timeout = setTimeout(this.next.bind(this), 2000);
      return;
    }

    if (page) {
      let currentIndex = activeAdvertisements.indexOf(page);

      let nextIndex = (currentIndex + 1) % activeAdvertisements.length;


      page.controller.hide();

      page = activeAdvertisements[nextIndex];
    } else {
      page = activeAdvertisements[0];
    }

    if (!page) {
      return;
    }

    page.controller.show();

    if (page.controller.kindValue != "youtube")
      this.timeout = setTimeout(
        this.next.bind(this),
        page.controller.durationValue * 1000
      );
  }
}
